import InstagramIcon from "@/assets/colorable/instagram.svg?react";
import TiktokIcon from "@/assets/colorable/tiktok.svg?react";
import EmptySocialLink from "@/components/Common/Influencer/InfluencerCard/EmptySocialLink";
import clsxm from "@/lib/clsxm";
import {type FC} from "react";

const SocialProfileLink: FC<{
  className?: string;
  iconClassName?: string;
  platform: "tiktok" | "instagram";
  showLogo?: boolean;
  username: string | null | undefined;
  withSmallGap?: boolean;
}> = ({className, iconClassName, platform, showLogo = true, username, withSmallGap = false}) => {
  const platformConfig = {
    tiktok: {baseUrl: "https://www.tiktok.com/@", Icon: TiktokIcon},
    instagram: {baseUrl: "https://www.instagram.com/", Icon: InstagramIcon},
  };

  const {baseUrl, Icon} = platformConfig[platform];

  if (!username) {
    return <EmptySocialLink socialPlatform={platform} />;
  }

  return (
    <div
      onClick={event => {
        event.stopPropagation();
        window.open(`${baseUrl}${username}`, "_blank");
      }}
      className={clsxm("flex min-w-0 cursor-pointer items-center", withSmallGap ? "gap-0.5" : "gap-2")}>
      {showLogo && <Icon className={clsxm("text-primary-dark-solid size-4 shrink-0", iconClassName)} />}
      <span className={clsxm("text-primary-dark-solid truncate text-lg leading-none", className)}>{username}</span>
    </div>
  );
};

export default SocialProfileLink;
